import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { HookEnrollment } from '../../components/hook/HookEnrollment';

export const StudentActivity: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          My Learning Hooks
        </h1>
        <p className="text-gray-600">
          Welcome, {user?.first_name}! View your learning hooks and progress here.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-md">
        <HookEnrollment />
      </div>
    </div>
  );
};
